import { Alert, Snackbar as SnackbarMUI } from '@mui/material'
import React from 'react'
import { useAppDispatch, useAppSelector } from '../hooks/reduxHooks'
import { closeMessage } from '../services/redux/snackbar/snackbar-actions'
import { isSnackbarOpen, getSnackbarMessage } from '../services/redux/snackbar/snackbar-selectors'

const Snackbar: React.FC = () => {
    const dispatch = useAppDispatch()

    const { message, type } = useAppSelector(getSnackbarMessage)
    const snackbarOpen = useAppSelector(isSnackbarOpen)

    const handleClose = () => {
        dispatch(closeMessage())
    }

    return (
        <SnackbarMUI open={snackbarOpen} autoHideDuration={3000} onClose={handleClose}>
            <Alert elevation={6} variant='filled' onClose={handleClose} color={type}>
                {message}
            </Alert>
        </SnackbarMUI>
    )
}

export default Snackbar
